<div class="w-full px-4 sm:px-6 lg:px-8 pt-1.5 pb-1 sm:pt-4 bg-white" *ngIf="isStandalone">
  <app-breadcrum [data]="notificationBreadcrumbs"></app-breadcrum>
</div>
<div [class.px-4]="isStandalone" [class.sm:px-6]="isStandalone" [class.lg:px-8]="isStandalone">
<div
  class="notification-container flex w-full max-w-full flex-col justify-start items-start gap-4 md:gap-6 px-4 md:px-0"
>
  <div class="flex flex-col gap-1 w-full">
    <div class="flex justify-between items-center w-full">
      <div
        class="text-black text-xl md:text-[24px] font-bold leading-6 md:leading-8"
      >
        Notifications and Alerts
      </div>
      <div class="w-6 h-6 cursor-pointer" (click)="togglePanel()">
        <img src="./../../../assets/notification/setting.png" alt="setIcon" />
      </div>
    </div>
    <p
      class="text-black text-sm md:text-base font-medium leading-5 md:leading-6"
    >
      Manage your notification preference and view recent alerts
    </p>
  </div>

  <div
    class="flex items-center gap-2 p-1 w-full md:w-72 rounded-lg bg-[#DFEBFB]"
  >
    <div
      class="flex-1 md:flex-none md:w-[91px] flex items-center justify-center gap-2 p-1 rounded-lg h-8 text-sm md:text-base cursor-pointer transition-colors"
      [ngClass]="
        activeTab === 'all'
          ? 'bg-[#307FE1] text-white'
          : 'bg-transparent text-black'
      "
      (click)="switchTab('all')"
    >
      All(5)
    </div>
    <div
      class="flex-1 md:flex-none flex items-center justify-center gap-2 p-1 rounded-lg text-sm md:text-base cursor-pointer transition-colors"
      [ngClass]="
        activeTab === 'orders'
          ? 'bg-[#307FE1] text-white'
          : 'bg-transparent text-black'
      "
      (click)="switchTab('orders')"
    >
      Orders
    </div>
    <div
      class="flex-1 md:flex-none flex items-center justify-center gap-2 p-1 rounded-lg text-sm md:text-base cursor-pointer transition-colors"
      [ngClass]="
        activeTab === 'offers'
          ? 'bg-[#307FE1] text-white'
          : 'bg-transparent text-black'
      "
      (click)="switchTab('offers')"
    >
      Offers
    </div>
    <div
      class="flex-1 md:flex-none flex items-center justify-center gap-2 p-1 rounded-lg text-sm md:text-base cursor-pointer transition-colors"
      [ngClass]="
        activeTab === 'other'
          ? 'bg-[#307FE1] text-white'
          : 'bg-transparent text-black'
      "
      (click)="switchTab('other')"
    >
      Other
    </div>
  </div>

  <div class="self-stretch flex flex-col justify-start items-start w-full">
    <!-- 1st Notification item -->
    <div
      class="self-stretch px-3 md:px-3 py-3 md:py-4 bg-slate-50 border-b border-Input-field-Stroke inline-flex justify-start items-start gap-3 md:gap-4 w-full cursor-pointer hover:bg-slate-100 transition-colors"
      (click)="onNotificationClick('order', '1234567891')"
    >
      <!-- <div class="flex gap-2 p-4 items-start border-b border-gray-300 bg-[#F8FAFF]"> -->
      <div
        class="flex justify-center items-center w-8 h-8 md:w-6 md:h-6 shrink-0 bg-[#DBE9FE] rounded-full md:bg-transparent md:rounded-none"
      >
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      
          <circle cx="20" cy="20" r="20" fill="#DBE9FE" />

          <g transform="translate(8, 8)">
            <path
              d="M14 18V10M14 18H16M14 18H10.5M5 18H6.5M14 10V7C14 6.44772 13.5523 6 13 6H5C4.44772 6 4 6.44772 4 7V9M14 10H18.1716C18.702 10 19.2107 10.2107 19.5858 10.5858L21.4142 12.4142C21.7893 12.7893 22 13.298 22 13.8284V17C22 17.5523 21.5523 18 21 18H20M10.5 18C10.5 19.1046 9.60457 20 8.5 20C7.39543 20 6.5 19.1046 6.5 18M10.5 18C10.5 16.8954 9.60457 16 8.5 16C7.39543 16 6.5 16.8954 6.5 18M20 18C20 19.1046 19.1046 20 18 20C16.8954 20 16 19.1046 16 18M20 18C20 16.8954 19.1046 16 18 16C16.8954 16 16 16.8954 16 18M4 9H8M4 9H2M10 12H4M4.5 15H3"
              stroke="#307FE1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </g>
        </svg> -->

        <img
          src="../../../assets/notification/1st_icon.png"
          alt=""
          class="w-5 h-5 md:w-6 md:h-6"
        />
      </div>

      <div class="flex-grow space-y-1 min-w-0">
        <div class="flex items-start justify-between">
          <div
            class="text-black text-sm md:text-base font-bold leading-5 md:leading-6 flex-1 pr-2"
          >
            Your package is on the way
          </div>
          <div
            class="text-[#464646] text-xs md:text-sm font-medium leading-4 md:leading-5 flex items-center gap-2 flex-shrink-0"
          >
            <span class="hidden md:inline">1 hour ago</span>
            <span class="md:hidden">1h</span>
            <span class="pt-[2px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="6"
                md:width="8"
                md:height="8"
                viewBox="0 0 8 8"
                fill="none"
              >
                <circle cx="4" cy="4" r="4" fill="#307FE1" />
              </svg>
            </span>
          </div>
        </div>

        <div
          class="text-[#777] text-xs md:text-sm font-medium leading-4 md:leading-5"
        >
          Your order #1234567891 has been shipped and will arrive tomorrow.
        </div>
      </div>
    </div>

    <!-- 2nd notification item -->

    <!-- <div class="flex gap-2 p-4 items-start border-b border-gray-300 bg-[#F8FAFF]">
       -->
    <div
      class="self-stretch px-3 md:px-3 py-3 md:py-4 bg-slate-50 border-b border-Input-field-Stroke inline-flex justify-start items-start gap-3 md:gap-4 w-full cursor-pointer hover:bg-slate-100 transition-colors"
      (click)="onNotificationClick('cart')"
    >
      <div
        class="flex justify-center items-center w-8 h-8 md:w-6 md:h-6 shrink-0 bg-[#FEF3C7] rounded-full md:bg-transparent md:rounded-none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          md:width="40"
          md:height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <circle cx="20" cy="20" r="20" fill="#FEF3C7" />
          <g transform="translate(8, 8) scale(0.833)">
            <path
              d="M10 19.999C10.8284 19.999 11.5 20.6706 11.5 21.499C11.5 22.3275 10.8284 22.999 10 22.999C9.17157 22.999 8.5 22.3275 8.5 21.499C8.5 20.6706 9.17157 19.999 10 19.999ZM17 19.999C17.8284 19.999 18.5 20.6706 18.5 21.499C18.5 22.3275 17.8284 22.999 17 22.999C16.1716 22.999 15.5 22.3275 15.5 21.499C15.5 20.6706 16.1716 19.999 17 19.999ZM3.32422 1.19922C4.69804 1.19922 5.88483 2.17986 6.11426 3.53711L6.39551 5.19922H20.9854C22.1518 5.19926 23.037 6.28747 22.7451 7.43848L21.415 12.6807C21.0976 13.9326 19.9617 14.7988 18.6719 14.7988H8.78906C8.51579 14.7988 8.25043 14.7584 7.99805 14.6855L8.25391 16.1992C8.36694 16.8676 8.76872 17.1992 9.26855 17.1992H19L19.082 17.2031C19.4853 17.2442 19.7998 17.5849 19.7998 17.999C19.7998 18.4409 19.4418 18.7988 19 18.7988H9.26855C7.81659 18.7988 6.88912 17.7218 6.67676 16.4658L6 12.4609L4.92969 6.13281L4.53613 3.80371C4.43953 3.23221 3.93355 2.79883 3.32422 2.79883H2C1.55817 2.79883 1.2002 2.44085 1.2002 1.99902C1.2002 1.5572 1.55817 1.19922 2 1.19922H3.32422ZM7.57715 12.1943C7.67373 12.7657 8.17989 13.1991 8.78906 13.1992H18.6719C19.2436 13.1992 19.7302 12.8158 19.8643 12.2871L21.1934 7.04492C21.2216 6.93367 21.1384 6.79887 20.9854 6.79883H6.66602L7.57715 12.1943Z"
              fill="#D97708"
            />
          </g>
        </svg>
      </div>

      <div class="flex-grow space-y-1 min-w-0">
        <!-- Title and timestamp on the same row -->
        <div class="flex justify-between items-start">
          <div
            class="text-black text-sm md:text-base font-bold leading-5 md:leading-6 flex-1 pr-2"
          >
            Items in your cart
          </div>
          <div
            class="text-[#464646] text-xs md:text-sm font-medium leading-4 md:leading-5 flex items-center gap-2 flex-shrink-0"
          >
            <span class="hidden md:inline">2 hour ago</span>
            <span class="md:hidden">2h</span>
            <span class="pt-[2px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="6"
                md:width="8"
                md:height="8"
                viewBox="0 0 8 8"
                fill="none"
              >
                <circle cx="4" cy="4" r="4" fill="#307FE1" />
              </svg>
            </span>
          </div>
        </div>

        <!-- Description -->
        <div
          class="text-[#777] text-xs md:text-sm font-medium leading-4 md:leading-5"
        >
          You left items in your cart. Complete your purchase now.
        </div>
      </div>
    </div>

    <!-- 3rd notification item -->

    <!-- <div class="flex gap-2 p-4 items-start border-b border-gray-300 bg-[#F8FAFF]"> -->
    <div
      class="self-stretch px-3 md:px-3 py-3 md:py-4 bg-slate-50 border-b border-Input-field-Stroke inline-flex justify-start items-start gap-3 md:gap-4 w-full cursor-pointer hover:bg-slate-100 transition-colors"
      (click)="onNotificationClick('order', '1234567890')"
    >
      <div
        class="flex justify-center items-center w-8 h-8 md:w-6 md:h-6 shrink-0 bg-[#DBE9FE] rounded-full md:bg-transparent md:rounded-none"
      >
        <img
          src="../../../assets/notification/1st_icon.png"
          alt=""
          class="w-5 h-5 md:w-6 md:h-6"
        />
      </div>
      <div class="flex-grow min-w-0">
        <div class="flex justify-between items-start mb-1">
          <div
            class="text-black text-sm md:text-base font-bold leading-5 md:leading-6 flex-1 pr-2"
          >
            Package delivered
          </div>
          <div
            class="text-[#464646] text-xs md:text-sm font-medium leading-4 md:leading-5 flex-shrink-0"
          >
            <span class="hidden md:inline">1 days ago</span>
            <span class="md:hidden">1d</span>
          </div>
        </div>
        <div
          class="text-[#777] text-xs md:text-sm font-medium leading-4 md:leading-5"
        >
          Your order #1234567890 has been delivered.
        </div>
      </div>
    </div>

    <!-- 4th notification item -->
    <!-- <div class="flex gap-2 p-4 items-start border-b border-gray-300 bg-[#F8FAFF]"> -->
    <div
      class="self-stretch px-3 md:px-3 py-3 md:py-4 bg-slate-50 border-b border-Input-field-Stroke inline-flex justify-start items-start gap-3 md:gap-4 w-full cursor-pointer hover:bg-slate-100 transition-colors"
      (click)="onNotificationClick('offer')"
    >
      <div
        class="flex justify-center items-center w-8 h-8 md:w-6 md:h-6 shrink-0 bg-green-100 rounded-full md:bg-transparent md:rounded-none"
      >
        <img
          src="../../../assets/notification/4th_icon.png"
          class="w-5 h-5 md:w-6 md:h-6"
        />
      </div>
      <div class="flex-grow space-y-1 min-w-0">
        <!-- Header and timestamp in the same row -->
        <div class="flex justify-between items-center">
          <div
            class="text-black text-sm md:text-base font-bold leading-5 md:leading-6 flex-1 pr-2"
          >
            New coupon available
          </div>
          <div
            class="text-[#464646] text-xs md:text-sm font-medium leading-4 md:leading-5 flex-shrink-0"
          >
            <span class="hidden md:inline">2 days ago</span>
            <span class="md:hidden">2d</span>
          </div>
        </div>

        <!-- Description -->
        <div
          class="text-[#777] text-xs md:text-sm leading-4 md:leading-5 font-medium"
        >
          Use code <strong class="text-black font-bold">TMOL</strong> for 15%
          off your next purchase.
        </div>
      </div>
    </div>
  </div>

  <!-- Overlay Panel Converted with Tailwind (already tailwindified by you) -->
  <div
    *ngIf="showPanel"
    class="fixed inset-0 bg-black bg-opacity-30 flex z-50"
    [class]="isMobile ? 'items-end' : 'justify-end'"
  >
    <div
      class="bg-white shadow-lg transform transition-transform duration-300 ease-in-out flex flex-col"
      [class]="
        isMobile ? 'w-full h-100 rounded-t-2xl' : 'h-full sm:max-w-md w-full'
      "
      [style.transform]="
        isMobile
          ? showPanel
            ? 'translateY(0)'
            : 'translateY(100%)'
          : showPanel
            ? 'translateX(0)'
            : 'translateX(100%)'
      "
    >
      <div class="border-b p-4 flex justify-between items-center">
        <h2 class="text-[#0A0A5F] text-[24px] leading-[32px] font-bold">
          Notification Preferences
        </h2>
        <button
          class="text-2xl font-bold text-gray-500 hover:text-gray-700"
          (click)="closePanel()"
        >
          &times;
        </button>
      </div>
      <div class="p-4 space-y-6">
        <p class="text-gray-600">
          Get notified about order status, returns, offers and Rewire
          program notifications.
        </p>
        <div *ngFor="let item of notifications">
          <div class="flex justify-between items-center">
            <div>
              <div class="font-semibold">{{ item.name }}</div>
              <div class="text-sm text-gray-500">
                Get updates via {{ item.name }}
              </div>
            </div>
            <label class="relative flex items-center cursor-pointer w-12 h-6">
              <input
                type="checkbox"
                [checked]="item.enabled"
                (change)="onCheckboxChange(item, $event)"
                class="sr-only peer"
              />
              <div
                class="w-full h-full bg-gray-300 rounded-full peer-checked:bg-blue-600 transition-colors duration-300 ease-in-out"
              ></div>
              <div
                class="absolute left-0 top-0 h-6 w-6 bg-white border border-gray-300 rounded-full shadow-md transform transition-transform duration-300 ease-in-out peer-checked:translate-x-6"
              ></div>
            </label>
          </div>
        </div>
      </div>
      <div class="border-t px-4 py-3 flex gap-4 bg-white mt-auto">
        <button
          class="flex-1 border border-blue-700 text-blue-700 px-4 py-2 rounded"
          (click)="closePanel()"
        >
          Cancel
        </button>
        <button
          class="flex-1 bg-blue-900 text-white px-4 py-2 rounded"
          (click)="savePanel()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>

</div>